import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { CidadeService } from './cidade.service';
import { CidadeDto } from './cidade.model';

/**
 * Cache service for cities.
 * Manages caching of city lists and invalidates cache when cities are created/updated/deleted.
 */
@Injectable({ providedIn: 'root' })
export class CidadeCacheService {
  private cache$?: Observable<CidadeDto[]>;

  constructor(private cidadeSvc: CidadeService) {}

  /**
   * Get all active cities with caching.
   * If cache is empty, fetches from API.
   */
  getAllActive(): Observable<CidadeDto[]> {
    if (!this.cache$) {
      this.cache$ = this.cidadeSvc.listAll().pipe(
        map((raw: any) => {
          const arr = Array.isArray(raw) ? raw : (raw?.data ?? []);
          return (arr as any[]).filter((cidade) => cidade?.ativo !== false);
        }),
        shareReplay(1)
      );
    }
    return this.cache$;
  }

  invalidate(): void {
    this.cache$ = undefined;
  }
}
